import React from 'react';
import { Table } from 'react-bootstrap';
import ReportHeader from './report_header';
import { ReturnNoteType } from '../../shared/models/returnNoteModels';
import { ReportType } from '../../shared/models/reportModels';
import { get } from 'lodash';

const report1Columns = [{
  id: 'Product',
  name: 'Product'
},
{
  id: 1,
  name: 'Time'
}];

const report2Columns = [{
    id: 'Product',
    name: 'Product'
},
{
    id: '1',
    name: 'Awaiting Inspection (col 1) to Inspection in Progress (col 2)'
},
{
    id: '2',
    name: 'Inspection in Progress (col 2) to Awaiting Parts (col 3)'
},
{
    id: '3',
    name: 'Awaiting Parts (col 3) to Awaiting Order Number (col 4)'
},
{
    id: '4',
    name: 'Awaiting Order Number (col 4) to Awaiting Payment (Col 5)'
},
{
    id: '5',
    name: 'Awaiting Payment (Col 5) to B.E.R. (col 6)'
},
{
    id: '6',
    name: 'B.E.R. (col 6) to Order Number or Payment Received (col 7)'
},
{
    id: '7',
    name: 'Order Number or Payment Received (col 7) to Repair in Progress (col 8)'
},
{
    id: '8',
    name: 'Repair in Progress (col 8) to Awaiting Dispatch (col 9)'
},
{
    id: '9',
    name: 'Awaiting Dispatch (col 9) to Dispatched (col10)'
}
];

const report3Columns = [{
    id: 'Product',
    name: 'Product'
},
{
    id: 1,
    name: 'Customer Name'
}, {
    id: 2,
    name: 'Serial Number'
},
{
    id: 3,
    name: 'Time in Repair'
}];

const PerMonthReport3Columns = [
    {
        id:'Year',
        name: 'Year'
      },
    {
    id: 'Month',
    name: 'Month'
  },
  
  {
    id:'Quantity',
    name: 'Quantity'
  }];

  const PerMonthProductTypeReport5Columns = [
    {
       id:'Year',
        name: 'Year'
      },
    {
    id: 'Month',
    name: 'Month'
  },
  {
    id:'Quantity',
    name: 'Quantity'
  },
  {
      id:'ProductName',
      name:'Product Name'
  }];
  const getAverageTimeInstatusDataReport11Columns=[
      {
        id:1,
        name:'ProductName'
      },
      {
        id:2,
        name:'AwaitingInspection'
      },
      {
        id:3,
        name:'InspectionInProgress'
      },
      {
          id:4,
          name:'AwaitingParts'
      },
      {
        id:5,
        name:'AwaitingOrderNumber'
      },
      {
        id:6,
        name:'AwaitingPayment'
      },
      {
        id:7,
        name:'BER'
      },
      {
        id:8,
        name:'OrderNumberOrPaymentReceived'
      },
      {
        id:9,
        name:'RepairInProgress'
      },
      {
        id:10,
        name:'AwaitingDispatch'
      }, {
        id:11,
        name:'Dispatched'
      }

    ];

interface IProps {
    reportForm: any;
    reportDetail: any;
}

const ReportDetail = ({ reportForm, reportDetail }: IProps) => {
    const { reportEnum } = reportForm;
    const getProductTypes = (id: number) => {
        if (id === ReturnNoteType.GasMixer) {
            return 'Gas Mixer'
        } else if (id === ReturnNoteType.GasAnalyser) {
            return 'Gas Analyser'
        } else if (id === ReturnNoteType.LeakDetection) {
            return 'Leak Detection'
        } else {
            return ''
        }
    }

    const getTimeString = (row: any) => {
        return row 
            ?`${row.day} days, ${row.hour} hours, ${row.minute} minutes`
            : '' ;
    }

    return <div>
        {reportEnum === ReportType.ColumnReport && <Table bordered size="sm">
            <ReportHeader
                reportForm={reportForm}
                columns={report2Columns}
            />
            <tbody>
                {reportDetail.map((row, index) =>
                    <tr key={index}>
                        <td>{row.productName}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col1'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col2'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col3'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col4'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col5'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col6'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col7'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col8'))}</td>
                        <td>{getTimeString(get(row, 'timeSpentByColumn.col9'))}</td>
                    </tr>)}
            </tbody>
        </Table>}

        {reportEnum === ReportType.RepairInProgress && <Table bordered size="sm" >
            <ReportHeader reportForm={reportForm} columns={report3Columns} />
            <tbody>
                {reportDetail.map((row, index) =>
                    <tr key={index}>
                        <td>{row.productName}</td>
                        <td>{row.customerName}</td>
                        <td>{row.serialNo}</td>
                        <td>{getTimeString(row)}</td>
                    </tr>
                )}
            </tbody>
        </Table>}

        {reportEnum === ReportType.ProductReport && <Table bordered size="sm" >

            <ReportHeader reportForm={reportForm} columns={report1Columns} />

            <tbody>
                {reportDetail.map((row, index) =>
                    <tr key={index}>
                        <td>{getProductTypes(row.id)}</td>
                        <td>{getTimeString(row)}</td>
                    </tr>
                )}
            </tbody>
        </Table>}
        {reportEnum === ReportType.PerMonthReport && <Table bordered size="sm" >
            <ReportHeader reportForm={reportForm} columns={PerMonthReport3Columns} />
            <tbody>
                {reportDetail.map((row, index) =>
                    <tr key={index}>
                        <td>{row.year}</td>
                        <td>{row.month}</td>
                        <td>{row.qty}</td>
                        
                    </tr>
                )}
            </tbody>
        </Table>}

        {reportEnum === ReportType.PerMonthByProductTypeReport && <Table bordered size="sm" >
            <ReportHeader reportForm={reportForm} columns={PerMonthProductTypeReport5Columns} />
            <tbody>
                {reportDetail.map((row, index) =>
                    <tr key={index}>
                         <td>{row.year}</td>
                        <td>{row.month}</td>
                        <td>{row.qty}</td>
                        <td>{row.productName}</td>
                    </tr>
                )}
            </tbody>
        </Table>}
        {reportEnum === ReportType.AverageTimeInstatusDataReport && <Table bordered size="sm" >
            <ReportHeader reportForm={reportForm} columns={getAverageTimeInstatusDataReport11Columns} />
            <tbody>
                {reportDetail.map((row, index) =>
                    <tr key={index}>
                        <td>{row.productName}</td>
                        <td>{row.awaitingInspection}</td>
                        <td>{row.inspectionInProgress}</td>
                        <td>{row.awaitingParts}</td>
                         <td>{row.awaitingOrderNumber}</td>
                         <td>{row.awaitingPayment}</td>
                         <td>{row.ber}</td>
                         <td>{row.orderNumberOrPaymentReceived}</td>
                         <td>{row.repairInProgress}</td>
                         <td>{row.awaitingDispatch}</td>
                         <td>{row.dispatched}</td>
                    </tr>
                )}
            </tbody>
        </Table>}
    </div>
}

export default ReportDetail;